<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">{{PageTitle}}</div>
                <div  class="col-xs-12 col-sm-12 col-md-3 col-lg-3 pull-right">
                    <v-select v-model="locationType"
                              name="locationType"
                              id="locationType"
                              label="text"
                              :clearable="false"
                              :searchable="false"
                              :filterable="false"
                              :options="locationTypeArr"
                              placeholder="Select Location Type">
                    </v-select>
                </div>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <form id="benefitForm">
                    <!--Advisor Section-->
                    <div class="row" style="display: none;">
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div class="card">
                                <div class="card-header">
                                    <h3>
                                        Advisors
                                        <button id="showAdvisorBtn" type="button" class="btn btn-primary pull-right"><i class="fa fa-eye" aria-hidden="true"></i></button>
                                        <button id="updateAdvisorBtn" type="button" class="btn btn-primary pull-right"><i class="fa fa-pencil" aria-hidden="true"></i></button>
                                    </h3>
                                </div>
                                <div class="card-body">
                                    <!--First Advisor-->
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                        <div class="form-group">
                                            <label>Details of First Advisor</label>
                                        </div>
                                        <!--Name-->
                                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <div class="form-group">
                                                <label for="firstName">Name<span class="text-danger">*</span></label>
                                                <input v-model="firstName" type="text" class="form-control" id="firstName" placeholder="Enter Name">
                                                <font class="text-danger">{{firstNameError}}</font>
                                            </div>
                                        </div>

                                        <!--Designation-->
                                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <div class="form-group">
                                                <label for="firstDesignation">Designation<span class="text-danger">*</span></label>
                                                <input v-model="firstDesignation" type="text" class="form-control" id="firstDesignation" placeholder="Enter Designation">
                                                <font class="text-danger">{{firstDesignationError}}</font>
                                            </div>
                                        </div>

                                        <!--phone 1-->
                                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <div class="form-group">
                                                <label for="firstPhonePrimary">Phone No. Primary<span class="text-danger">*</span></label>
                                                <input v-model="firstPhonePrimary" type="text" class="form-control" id="firstPhonePrimary" placeholder="Enter Phone No. Primary">
                                                <font class="text-danger">{{firstPhonePrimaryError}}</font>
                                            </div>
                                        </div>

                                        <!--phone 2-->
                                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <div class="form-group">
                                                <label for="firstPhoneSecondary">Phone No. Secondary</label>
                                                <input v-model="firstPhoneSecondary" type="text" class="form-control" id="firstPhoneSecondary" placeholder="Enter Phone No. Secondary">
                                                <font class="text-danger">{{firstPhoneSecondaryError}}</font>
                                            </div>
                                        </div>

                                        <!--Email-->
                                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <div class="form-group">
                                                <label for="firstEmail">Email<span class="text-danger">*</span></label>
                                                <input v-model="firstEmail" type="text" class="form-control" id="firstEmail" placeholder="Enter Email">
                                                <font class="text-danger">{{firstEmailError}}</font>
                                            </div>
                                        </div>
                                    </div>
                                    <!--End First  Advisor-->
                                    <!--Second Advisor-->
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                        <div class="form-group">
                                            <label>Details of Second Advisor</label>
                                        </div>
                                        <!--Name-->
                                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <div class="form-group">
                                                <label for="secondName">Name<span class="text-danger">*</span></label>
                                                <input v-model="secondName" type="text" class="form-control" id="secondName" placeholder="Enter Name">
                                                <font class="text-danger">{{secondNameError}}</font>
                                            </div>
                                        </div>

                                        <!--Designation-->
                                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <div class="form-group">
                                                <label for="secondDesignation">Designation<span class="text-danger">*</span></label>
                                                <input v-model="secondDesignation" type="text" class="form-control" id="secondDesignation" placeholder="Enter Designation">
                                                <font class="text-danger">{{secondDesignationError}}</font>
                                            </div>
                                        </div>

                                        <!--phone 1-->
                                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <div class="form-group">
                                                <label for="secondPhonePrimary">Phone No. Primary<span class="text-danger">*</span></label>
                                                <input v-model="secondPhonePrimary" type="text" class="form-control" id="secondPhonePrimary" placeholder="Enter Phone No. Primary">
                                                <font class="text-danger">{{secondPhonePrimaryError}}</font>
                                            </div>
                                        </div>

                                        <!--phone 2-->
                                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <div class="form-group">
                                                <label for="secondPhoneSecondary">Phone No. Secondary</label>
                                                <input v-model="secondPhoneSecondary" type="text" class="form-control" id="secondPhoneSecondary" placeholder="Enter Phone No. Secondary">
                                                <font class="text-danger">{{secondPhoneSecondaryError}}</font>
                                            </div>
                                        </div>

                                        <!--Email-->
                                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <div class="form-group">
                                                <label for="secondEmail">Email<span class="text-danger">*</span></label>
                                                <input v-model="secondEmail" type="text" class="form-control" id="secondEmail" placeholder="Enter Email">
                                                <font class="text-danger">{{secondEmailError}}</font>
                                            </div>
                                        </div>
                                    </div>
                                    <!--End Second Advisor-->
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <div class="button-demo">
                                            <input id="updateAdvisor" type="submit" value="Update" class="pull-right btn btn-primary" v-on:click.prevent="updateAdvisor()">
                                        </div>
                                    </div>
                                    <div class="clearfix"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--End Advisor Section-->
                    <div class="row">
                        <!--View Update Uploads Section-->
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <div class="card">
                                <div class="card-header">
                                    <h3>
                                        401k Documents
                                        <button id="showUploads" type="button" class="ViewDocument btn btn-primary pull-right"><i class="fa fa-eye" aria-hidden="true"></i></button>
                                        <button id="editUploads" type="button" class="EditDocument btn btn-primary pull-right"><i class="fa fa-pencil" aria-hidden="true"></i></button>
                                    </h3>
                                </div>
                                <div class="card-body">
                                    <!--Doc Upload Section-->
                                    <div id="updateUploads">
                                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-group">
                                            <label for="drop1">Doc For<span class="text-danger">*</span></label>
                                            <v-select class=""
                                                      @input="changedValueDocument()"
                                                      v-model="selectedUpload"
                                                      name="selecteUpload"
                                                      id="selecteUpload"
                                                      label="text"
                                                      :searchable="false"
                                                      :filterable="false"
                                                      :options="DocumentArr"
                                                      placeholder="Select Option">
                                            </v-select>
                                            <font class="text-danger">{{docSelectError}}</font>
                                        </div>

                                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-group">
                                            <label for="drop1">Upload Doc<span class="text-danger">*</span></label>
                                            <template>
                                                <div id="app">
                                                    <vue-dropzone
                                                        id="drop1"
                                                        :options="dropzoneOptions"
                                                        ref="dropzone"
                                                        :destroyDropzone="false"
                                                        :headers="dropzoneOptions.headers"
                                                        @vdropzone-removed-file="removedSelectedFile"
                                                        @vdropzone-success="vfileSuccess"
                                                        @vdropzone-total-upload-progress="progressOfUload"
                                                        name="file"
                                                        >
                                                    </vue-dropzone>
                                                    <font class="text-danger">{{docUploadError}}</font>
                                                </div>
                                            </template>
                                        </div>
                                        <!--Error Alert-->
                                        <div class=" clearfix" >
                                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                <div class="alert alert-danger" id="alertError">
                                                    <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                                    <strong id="errorMsg" class="error"></strong>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="clearfix"></div>
                                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 button-demo">
                                            <input id="update" type="submit" value="Update" class="btn btn-primary pull-right" v-on:click.prevent="updateDocs('update')">
                                            <input id="archiveupdate" type="submit" value="Archive & Update" class="btn btn-primary pull-right mr-1" v-on:click.prevent="updateDocs('archive')">
                                        </div>
                                        <div class="clearfix"></div>
                                    </div>
                                    <!--End Doc Upload Section-->
                                    <!--View Upload Section-->
                                    <div id="viewUploads">
                                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-group selectedItem">
                                            <ul class="list-group">
                                                <template v-for="(text, index) in doc401kListNew">
                                                    <li class="list-group-item d-flex justify-content-between align-items-center">
                                                        <a :href="text.doc_path" target="_blank">{{text.doc_name}}</a>
                                                        <template v-if="text.status == 'active'">
                                                            <input class="btn btn-danger btn-xs pull-right" value="Inactive" type="button" v-on:click="status401kDocs(text.id)"/>
                                                        </template>
                                                        <template v-if="text.status == 'inactive'">
                                                            <input class="btn btn-success btn-xs pull-right" value="Active" type="button" v-on:click="status401kDocs(text.id)"/>
                                                        </template>
                                                    </li>
                                                </template>
                                            </ul>
                                        </div>
                                        <div class="clearfix"></div>
                                    </div>
                                    <!--End View Upload Section-->
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <div class="card">
                                <div class="card-header">
                                    <h3>
                                        Upload Documents
                                        <button id="showDocListBtn" type="button" class="btn btn-primary pull-right"><i class="fa fa-eye" aria-hidden="true"></i></button>
                                        <button id="addDocBtn" type="button" class="btn btn-primary pull-right"><i class="fa fa-plus" aria-hidden="true"></i></button>
                                    </h3>
                                </div>
                                <div class="card-body">

                                    <!--Upload Docs Section-->
                                    <div id="policiesFormsDocsDiv" class="policiesFormsDocsDiv">
                                        <div id="myRadioGroup">
                                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                <span id="myForm">
                                                    <label><input id="uploadManually" type="radio" name="cars" value="2" checked="checked"/>Upload Docs</label>
                                                    <label><input id="vodepUrl" type="radio" name="cars" value="3">Enter URL</label>
                                                </span>
                                            </div>
                                            <br/>
                                            <br/>
                                            <!--Button Title-->
                                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                <div class="form-group">
                                                    <label for="buttonTitle">Button Title</label>
                                                    <input v-model="buttonTitle" type="text" class="form-control" id="buttonTitle" placeholder="Button Title" />
                                                    <font class="text-danger">{{buttonTitleError}}</font>
                                                </div>
                                            </div>

                                            <!--Upload Docs-->
                                            <div id="Cars2" class="desc">
                                                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                    <template>
                                                        <div id="dropzone">
                                                            <vue-dropzone
                                                                id="drop1"
                                                                :options="dropzoneOptionsDocFile"
                                                                ref="dropzoneDocFile"
                                                                :destroyDropzone="false"
                                                                :headers="dropzoneOptionsDocFile.headers"
                                                                @vdropzone-removed-file="removedSelectedDocFile"
                                                                @vdropzone-success="vDocfileSuccess"
                                                                @vdropzone-total-upload-progress="progressOfUload"
                                                                name="file"
                                                                >
                                                            </vue-dropzone>
                                                            <font class="text-danger"> {{docUploadError}}</font>
                                                        </div>
                                                    </template>
                                                </div>
                                            </div>

                                            <!--Enter Button URL-->
                                            <div class="clearfix"></div>
                                            <div div id="Cars3" class="desc" style="display: none;">
                                                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                    <div class="form-group">
                                                        <label for="buttonURL">Button URL</label>
                                                        <input v-model="buttonURL" type="text" class="form-control" id="buttonURL" placeholder="Button URL">
                                                        <font class="text-danger">{{buttonURLError}}</font>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!--Error Alert-->
                                        <div class="clearfix" >
                                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                <div class="alert alert-danger" id="alertErrorDoc">
                                                    <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                                    <strong id="errorMsgDoc" class="error"></strong>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="clearfix" ></div>
                                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <div class="button-demo">
                                                <button id="savePoliciesFormsDocs" type="button" class="mt-5 btn btn-primary pull-right" v-on:click="saveUploadedDoc()">Save</button>
                                                <button id="cancleDocUpload" type="button" class="mr-1 btn mt-5 btn-primary pull-right" v-on:click="onCancleUpload()">Cancel</button>
                                            </div>
                                        </div>
                                    </div>
                                    <!--End Upload Doc Section-->

                                    <!--List Doc Section-->

                                    <div id="listPoliciesFormsDocsDiv" class="listPoliciesFormsDocsDiv">
                                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                            <div class="form-group">
                                                <label for="buttonTitle">Uploaded Document List</label>
                                                <div class="form-line">
                                                    <ul>
                                                        <draggable v-model="doc401kList" v-on:change="changeButtonPosition()" class="drag-view">
                                                            <template v-for="(text, index) in doc401kList">
                                                                <li>
                                                                    <button title='Delete Doc' id="deleteDoc" class="btn btn-primary mb-1"  v-on:click.prevent="deleteDoc(text.id)"><i class="fa fa-trash" aria-hidden="true"></i></button>
                                                                    <template v-if="text.button_document != ''">
                                                                        <button title='Archive Doc' id="archivesDoc" class="mb-1 btn btn-primary"  v-on:click.prevent="archivesDoc(text.id)"><i class="fa fa-archive" aria-hidden="true"></i></button>
                                                                        <!-- <a :href="text.button_document" target="_blank"> {{text.button_title}}</a> -->
                                                                        <a href="#" :id="'id' + index" @click="getSignedUrlPath(text.button_document)"> {{text.button_title}}</a>
                                                                    </template>
                                                                    <template v-if="text.button_url != ''">
                                                                        <a :href="text.button_url" target="_blank"> {{text.button_title}}</a>
                                                                    </template>
                                                                </li>
                                                            </template>
                                                        </draggable>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div class=" clearfix" >
                                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                <div class="alert alert-danger view" id="alertErrorDoc">
                                                    <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                                    <strong id="errorMsgDocview" class="error"></strong>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <!--End List Doc Section-->
                                    <div class="clearfix"></div>

                                </div>
                                <div class="card-body">
                                    <!--Content-->
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <div class="card">
                                <div class="card-header">
                                    <h3>
                                        Website & Contact Details
                                        <button id="showContent" type="button" class="btn btn-primary pull-right"><i class="fa fa-eye" aria-hidden="true"></i></button>
                                        <button id="updateContentBtn" type="button" class="btn btn-primary pull-right"><i class="fa fa-pencil" aria-hidden="true"></i></button>
                                    </h3>
                                </div>
                                <div class="card-body">
                                    <!--Instruction Title-->
                                    <div class="clearfix"></div>
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <div class="form-group">
                                            <label for="instructionTitle">Instruction Title</label>
                                            <input v-model="instructionTitle" type="text" class="form-control" id="instructionTitle" placeholder="Instruction Title">
                                            <!--<font class="text-danger">{{descriptionError}}</font>-->
                                        </div>
                                    </div>
                                    <!--Instruction Steps-->
                                    <div class="clearfix"></div>
                                    <!--At Update Instruction Steps-->
                                    <div class=" clearfix"></div>
                                    <div id="updateInstruction">
                                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <div class="col-xs-2">
                                                <button type="button" v-on:click="addNewStep" class="btn btn-block btn-success">
                                                    <i class="fa fa-plus" aria-hidden="true"></i>
                                                </button>
                                            </div>
                                            <div class="col-xs-10">
                                                Would you like add more points?
                                            </div>
                                        </div>
                                        <div v-for="(instruction, index) in instructions">
                                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                <div class="col-sm-2">
                                                    <label>&nbsp;</label>
                                                    <button type="button" v-on:click="removeStep(index)" class="btn btn-block btn-danger">
                                                        <i class="fa fa-times" aria-hidden="true"></i>
                                                    </button>
                                                </div>
                                                <div class="col-lg-10 col-md-10 col-sm-10 col-xs-10">
                                                    <label>Point</label>
                                                    <input v-model="instruction.step" type="text" id="instructionSteps"
                                                           name="instructions[][step]" class="form-control" placeholder="Instruction Step">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="clearfix"></div>
                                    </div>
                                    <!--<br><br>-->
                                    <!--End Update Instruction Steps-->
                                    <!--At View Instruction Steps-->
                                    <div id="viewInstruction">
                                        <!--<div class="row clearfix"></div>-->
                                        <div v-for="(instruction, index) in instructionsForShow" >
                                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                <label>{{index +1}}. {{instructionsForShow[index].step}}</label>
                                            </div>
                                        </div>
                                        <div class="clearfix"></div>
                                        <br/>
                                    </div>
                                    <!--End View Instruction Steps-->
                                    <!--Website Link-->
                                    <div class="clearfix"></div>
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <div class="form-group">
                                            <label for="websiteLink">Website Link<span class="text-danger">*</span></label>
                                            <input v-model="websiteLink" type="text" class="form-control" id="websiteLink" placeholder="Website Link">
                                            <font class="text-danger">{{websiteLinkError}}</font>
                                        </div>
                                    </div>
                                    <div class="clearfix"></div>
                                    <!--Contact No-->
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <div class="form-group">
                                            <label for="contactNumber">Contact Number<span class="text-danger">*</span></label>
                                            <input v-model="contactNumber" type="text" class="form-control" id="contactNumber" placeholder="Contact Number">
                                            <font class="text-danger">{{contactNumberError}}</font>
                                        </div>
                                    </div>
                                    <div class="clearfix"></div>
                                    <!--Description-->
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <div class="form-group">
                                            <label for="description">Description</label>
                                            <textarea v-model="description" type="text" class="form-control" id="description" placeholder="Description"></textarea>
                                            <!--<font class="text-danger">{{descriptionError}}</font>-->
                                        </div>
                                    </div>
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 button-demo">
                                        <input id="updateContent" type="submit" value="Update" class="pull-right btn btn-primary" v-on:click.prevent="updateContent()">
                                    </div>
                                    <div class="clearfix"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <!--page content-->
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- /#page-content-wrapper -->
</template>

<script>
    var self;
    import vSelect from 'vue-select';
    import Vue from 'vue';
    import BackendFooter from '@/components/backend/partials/Footer';
    import SessioMixin from '../../../mixins/sessionmixin';
    import { HTTP } from '../../../http-common';
    import moment from 'moment';
    import vue2Dropzone from 'vue2-dropzone';
    import 'vue2-dropzone/dist/vue2Dropzone.min.css';
    import draggable from 'vuedraggable';
    var myDate = new Date();

    export default {
        name: 'AddDiscount',
        mixins: [SessioMixin],
        components: {
            'v-select': vSelect,
            vueDropzone: vue2Dropzone,
            'app-backend-footer': BackendFooter,
            draggable,
        },
        data() {
            return {
                locationType: {value: 'other', text: 'Other'},
                locationTypeArr: [
                    {value: 'other', text: 'Other'},
                    {value: 'Velocity SBA', text: 'Velocity SBA'}
                ],
                PageTitle: '401k',
                selectedUpload: '',
                docPath: '',
                docType: '',
                DocumentArr: [{text: '', value: ''}],
                selectedOption: '',
                selected: '',

                //Label
                englishKitDoc: '',
                spanishKitDoc: '',
                loanPayoffInstruction: '',
                registrationInstruction: '',

                options: {
                    /*language_url: 'http://example.com/js/langs/fa_IR.js' //This url points to location of persian language file.*/
                },
                //DropZone
                dropzoneOptions: {
                    timeout: 3000000,
                    url: process.env.ROOT_API + "/uploadmedia",
                    method: 'POST',
                    paramName: 'file',
                    autoProcessQueue: true,
                    maxFilesize: 150, //MB
                    maxFiles: 1,
                    thumbnailWidth: 150, // px
                    thumbnailHeight: 150,
                    addRemoveLinks: true,
                    acceptedFiles: ".pdf, .doc, .docx",
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        // 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, DELETE',
                        // 'Access-Control-Allow-Headers': 'Content-Type, Authorization, X-Requested-With',//'Origin, X-Requested-With, Content-Type, Accept, X-File-Name, X-File-Size, X-File-Type',
                        //'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    dictFileTooBig: "File is too big ({{filesize}}mb). Max allowed file size is {{maxFilesize}}mb",
                    dictInvalidFileType: "Invalid File Type",
                    dictCancelUpload: "Cancel",
                    dictRemoveFile: "Remove",
                    dictMaxFilesExceeded: "Only 1 file is allowed",
                    dictDefaultMessage: "Drop file here to upload",
                },
                //DropZone For Doc Upload
                dropzoneOptionsDocFile: {
                    timeout: 3000000,
                    url: process.env.ROOT_API + "/uploadmedia",
                    method: 'POST',
                    paramName: 'file',
                    autoProcessQueue: true,
                    maxFilesize: 150, //MB
                    maxFiles: 1,
                    thumbnailWidth: 150, // px
                    thumbnailHeight: 150,
                    addRemoveLinks: true,
                    acceptedFiles: ".pdf, .doc, .docx",
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        // 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, DELETE',
                        // 'Access-Control-Allow-Headers': 'Content-Type, Authorization, X-Requested-With',//'Origin, X-Requested-With, Content-Type, Accept, X-File-Name, X-File-Size, X-File-Type',
                        //'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    dictFileTooBig: "File is too big ({{filesize}}mb). Max allowed file size is {{maxFilesize}}mb",
                    dictInvalidFileType: "Invalid File Type",
                    dictCancelUpload: "Cancel",
                    dictRemoveFile: "Remove",
                    dictMaxFilesExceeded: "Only 1 file is allowed",
                    dictDefaultMessage: "Drop file here to upload",
                },

                docPaths: '',
                docTypes: '',
                selectedRadioButton: '',
                uploadLimitCounter: 0,

                buttonTitle: '',
                buttonURL: '',
                isDocUploaded: false,
                doc401kList: [],
                buttonTitleError: '',
                buttonURLError: '',
                docUploadError: '',
                doc401kListNew: [],
                docStatus: '',
                docStatusWhileList: '',

                //Frontend Errors
                isFileUploaded: false,
                docUploadError: '',
                docSelectError: '',
                websiteLinkError: '',
                contactNumberError: '',

                firstNameError: '',
                firstDesignationError: '',
                firstPhonePrimaryError: '',
                firstPhoneSecondaryError: '',
                firstEmailError: '',

                secondNameError: '',
                secondDesignationError: '',
                secondPhonePrimaryError: '',
                secondPhoneSecondaryError: '',
                secondEmailError: '',

                // Content
                instruction: {
                    step: ''
                },
                instructions: [{
                        step: ''
                    }],
                instructionTitle: '',
                instructionsForShow: {
                    step: ''
                },
                websiteLink: '',
                contactNumber: '',
                description: '',

                // Advisor
                firstName: '',
                firstDesignation: '',
                firstPhonePrimary: '',
                firstPhoneSecondary: '',
                firstEmail: '',

                secondName: '',
                secondDesignation: '',
                secondPhonePrimary: '',
                secondPhoneSecondary: '',
                secondEmail: '',
                fileUploaded: true,
            }
        },
        watch: {
            locationType: function (locationType) {
                self.list401kDocs();
                self.load401kDocs();
                self.load401kContent();
                self.load401kAdvisor();
                self.loadDocName();
            },
        },
        beforeMount: function () {
            self = this;
            self.checkLogin();
        },
        mounted: function () {
            self.showLoader();
            // List Upload Docs
            $(".alert-danger.view").hide();
            self.IntialConditionForDocUpload();
            self.selectedRadioButton = 2;
            $("#showDocListBtn").click(function () {
                self.addDocListViewClick();
            });
            $("#addDocBtn").click(function () {
                if (self.uploadLimitCounter < 2) {
                    self.addDocClick();
                } else {
                    $("#errorMsgDocview").html("You can upload max 2 files");
                    $(".alert-danger.view").removeClass("hide");
                    $(".alert-danger.view").addClass("show");
                    setTimeout(function () {
                        $(".alert-danger.view").removeClass("show");
                        $(".alert-danger.view").addClass("hide");
                    }, 5000);
                    return
                }
            });
            // End List Upload Docs

            var path = window.location.pathname;
            var segments = path.split("/");

            // if (segments[2] == 'viewupdate401k') {
            //     if (segments[3]) {
            //         self.loadPoliciesAndForms();
            //         $("#addAndContinueBenifitBtn").hide();
            //         $("#addBenifitBtn").val("Update");
            //         // self.pageTitle = "Edit Policies And Forms";
            //     }
            // } else {
            //     self.selectedRadioButton = 2;
            // }

            $(document).ready(function () {
                $("input[name$='cars']").click(function () {
                    var test = $(this).val();

                    $("div.desc").hide();
                    $("#Cars" + test).show();
                    self.buttonTitle = "";
                    self.buttonURLError = "";
                    self.buttonTitleError = "";
                });
            });

            $('#myForm input').on('change', function () {
                var selectedRadioButton = $('input[name=cars]:checked', '#myForm').val();
                self.selectedRadioButton = selectedRadioButton;
                if (self.selectedRadioButton == 3) {
                    self.removeAllDocFiles();
                    self.docPaths = '';
                    self.isDocUploaded = true;
                } else if (self.selectedRadioButton == 2) {
                    self.isDocUploaded = false;
                }
            });
            self.list401kDocs();
            $("#alertErrorDoc").hide();

            // Doc Section
            $("#selecteUpload").on('keyup', function () {
                self.docSelectError = '';
            });
            $("#updateUploads").hide();
            $(".ViewDocument").hide();
            $("#viewUploads").show();

            $("#editUploads").click(function () {
                $(".ViewDocument").show();
                $(".EditDocument").hide();
                $("#updateUploads").show();
                $("#viewUploads").hide();
            });
            $("#showUploads").click(function () {
                $(".ViewDocument").hide();
                $(".EditDocument").show();
                $("#updateUploads").hide();
                $("#viewUploads").show();
            });

            $('#selecteUpload').on('change', function (e) {
                var optionSelected = $("option:selected", this);
                self.selectedOption = this.value;
                self.docSelectError = '';
            });
            // End Doc Section

            // Content Section

            $("#viewInstruction").show();
            $("#updateInstruction").hide();
            $("#showContent").hide();
            $("#updateContentBtn").show();
            $("#updateContent").hide();
            document.getElementById("instructionTitle").disabled = true;
            document.getElementById("websiteLink").disabled = true;
            document.getElementById("contactNumber").disabled = true;
            document.getElementById("description").disabled = true;

            $("#updateContentBtn").click(function () {
                $("#showContent").show();
                $("#updateContentBtn").hide();
                $("#updateInstruction").show();
                $("#viewInstruction").hide();
                $("#updateContent").show();
                document.getElementById("instructionTitle").disabled = false;
                document.getElementById("websiteLink").disabled = false;
                document.getElementById("contactNumber").disabled = false;
                document.getElementById("description").disabled = false;
            });

            $("#showContent").click(function () {
                $("#showContent").hide();
                $("#updateContentBtn").show();
                $("#updateInstruction").hide();
                $("#viewInstruction").show();
                $("#updateContent").hide();
                document.getElementById("instructionTitle").disabled = true;
                document.getElementById("websiteLink").disabled = true;
                document.getElementById("contactNumber").disabled = true;
                document.getElementById("description").disabled = true;
            });

            // End Content Section

            // Advisor Section
            self.intialConditionForAdvisor();
            $("#showAdvisorBtn").click(function () {
                self.onClickShowAdvisor();
            });
            $("#updateAdvisorBtn").click(function () {
                self.onClickUpdateAdvisor();
            });
            // End Advisor Section

            $("#contactNumber").on('keyup', function () {
                self.contactNumberError = '';
            });
            $("#websiteLink").on('keyup', function () {
                self.websiteLinkError = '';
            });
            $("#firstName").on('keyup', function () {
                self.firstNameError = '';
            });
            $("#firstDesignation").on('keyup', function () {
                self.firstDesignationError = '';
            });
            $("#firstPhonePrimary").on('keyup', function () {
                self.firstPhonePrimaryError = '';
            });
            $("#firstPhoneSecondary").on('keyup', function () {
                self.firstPhoneSecondaryError = '';
            });
            $("#firstEmail").on('keyup', function () {
                self.firstEmailError = '';
            });
            $("#secondName").on('keyup', function () {
                self.secondNameError = '';
            });
            $("#secondDesignation").on('keyup', function () {
                self.secondDesignationError = '';
            });
            $("#secondPhonePrimary").on('keyup', function () {
                self.secondPhonePrimaryError = '';
            });
            $("#secondPhoneSecondary").on('keyup', function () {
                self.secondPhoneSecondaryError = '';
            });
            $("#secondEmail").on('keyup', function () {
                self.secondEmailError = '';
            });

            self.load401kDocs();
            self.load401kContent();
            self.load401kAdvisor();
            self.loadDocName();

            $("#alertError").hide();
        },

        methods: {
            status401kDocs(doc_id) {
                var fields = {
                    docId: doc_id,
                };
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                HTTP.post("changestatus401kdocs", fields, config)
                        .then(function (response) {
                            self.load401kDocs();
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                        });

            },
            changeButtonPosition() {
                var path = window.location.pathname;
                var segments = path.split("/");
                var fields = {
                    doc401kList: self.doc401kList,
                    id: segments[3],
                    location_type: self.locationType.value,
                };
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                HTTP.post("changebuttonposition401kdoc", fields, config)
                        .then(function (response) {
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            onCancleUpload() {
                self.addDocListViewClick();
            },
            IntialConditionForDocUpload() {
                $("#showDocListBtn").hide();
                $("#addDocBtn").show();
                $(".policiesFormsDocsDiv").hide();
                $(".listPoliciesFormsDocsDiv").show();
            },
            addDocClick() {
                $("#showDocListBtn").show();
                $("#addDocBtn").hide();
                $(".policiesFormsDocsDiv").show();
                $(".listPoliciesFormsDocsDiv").hide();
            },
            addDocListViewClick() {
                $("#showDocListBtn").hide();
                $("#addDocBtn").show();
                $(".policiesFormsDocsDiv").hide();
                $(".listPoliciesFormsDocsDiv").show();
            },

            deleteDoc(id) {
                var path = window.location.pathname;
                var segments = path.split("/");

                var fields = {mainId: segments[3], mapperId: id, location_type: self.locationType.value, };
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                this.$swal({
                    title: 'Are you sure?',
                    text: 'You can\'t revert your action',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes Delete it!',
                    cancelButtonText: 'No, Keep it!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        HTTP.post('deletedoc401kforselectedid', fields, config).
                                then(response => {
                                    self.$swal({
                                        type: 'success',
                                        html: "File Deleted Successfully",
                                        showConfirmButton: false,
                                        timer: 5000,
                                    });
                                    self.list401kDocs();
                                })
                                .catch(function (err) {
                                    if (err.response.status == 0) {
                                        self.error = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            self.$router.push("/login");
                                        }
                                        self.error = err.response.data.message;
                                    }
                                });
                        self.$swal({
                            title: 'Deleted',
                            type: 'success',
                            html: "You successfully deleted the record(s).",
                            showConfirmButton: false,
                            timer: 5000,
                        });
                    } else {
                        self.$swal({
                            title: 'Cancelled',
                            type: 'info',
                            html: "Your record(s) still intact",
                            showConfirmButton: false,
                            timer: 5000,
                        });
                    }
                });
            },
            archivesDoc(id) {
                var path = window.location.pathname;
                var segments = path.split("/");

                var fields = {mainId: segments[3], mapperId: id, location_type: self.locationType.value, };
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                this.$swal({
                    title: 'Are you sure?',
                    text: 'You can\'t revert your action',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes Archive it!',
                    cancelButtonText: 'No, Keep it!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        HTTP.post('archivedoc401kforselectedid', fields, config).
                                then(response => {
                                    self.$swal({
                                        type: 'success',
                                        text: 'File Archived Successfully',
                                        showConfirmButton: false,
                                        timer: 5000,
                                    });
                                    self.list401kDocs();
                                })
                                .catch(function (err) {
                                    if (err.response.status == 0) {
                                        self.error = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            self.$router.push("/login");
                                        }
                                        self.error = err.response.data.message;
                                    }
                                });
                        self.$swal({
                            title: 'Archived',
                            type: 'success',
                            html: "You successfully archived the record(s).",
                            showConfirmButton: false,
                            timer: 5000,
                        });
                    } else {
                        self.$swal({
                            title: 'Cancelled',
                            type: 'info',
                            html: "Your record(s) still intact",
                            showConfirmButton: false,
                            timer: 5000,
                        });
                    }
                });
            },

            checkDocForm: function () {
                var checked = true;
                if (!self.buttonTitle) {
                    self.buttonTitleError = "Button Title Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.selectedRadioButton == 2) {
                    if (self.isDocUploaded == false) {
                        self.docUploadError = "Please Upload File";
                        if (checked) {
                            checked = false;
                        }
                    }
                }
                if (self.fileUploaded == false) {
                    self.docUploadError = "Please Wait While File Is Being Uploaded";
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.selectedRadioButton == 3) {
                    if (!self.buttonURL) {
                        self.buttonURLError = "Please Enter URL";
                        if (checked) {
                            checked = false;
                        }
                    } else if (!self.validUrl(self.buttonURL)) {
                        self.buttonURLError = 'Please Enter Valid URL';
                        if (checked) {
                            checked = false;
                        }
                    }
                }

                return checked;
            },
            validUrl: function (url) {
                var re = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/;
                return re.test(url);
            },

            saveUploadedDoc() {
                self.checkDocForm();
                if (self.checkDocForm()) {
                    var path = window.location.pathname;
                    var segments = path.split("/");
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                    };
                    $("#savesavePoliciesFormsDocs").val("Saving ...");
                    $("#savesavePoliciesFormsDocs").prop("disabled", true);
                    var fields = {
                        location_type: self.locationType.value,
                        buttonTitle: self.buttonTitle,
                        docPaths: self.docPaths,
                        docTypes: self.docTypes,
                        buttonURL: self.buttonURL,
                        uploadedType: self.selectedRadioButton,
                        segment: segments[2],
                    };
                    self.showLoader();
                    HTTP.post("upload401kdocs", fields, config)
                            .then(function (response) {
                                if (response.data.status == "success") {
                                    $("#savesavePoliciesFormsDocs").val("Save");
                                    $("#savesavePoliciesFormsDocs").prop("disabled", false);
                                    $("#errorMsgDoc").html(response.data.content);
                                    $(".alert-danger").removeClass("hide");
                                    $(".alert-danger").addClass("show");
                                    self.list401kDocs();
                                    self.uploadLimitCounter++;

                                    setTimeout(function () {
                                        self.addDocListViewClick();
                                        $(".alert-danger").removeClass("show");
                                        $(".alert-danger").addClass("hide");
                                        self.removeAllDocFiles();
                                        self.buttonTitle = '';
                                        self.buttonURL = '';
                                    }, 5000);
                                } else {
                                    $("#savesavePoliciesFormsDocs").val("Save");
                                    $("#savesavePoliciesFormsDocs").prop("disabled", false);
                                    $("#errorMsgDoc").html(response.data.message);
                                    if (response.data.content.length > 0) {
                                        var err = "";
                                        err += response.data.content + "<br>";
                                        $("#errorMsgDoc").html(err);
                                    }
                                    $(".alert-danger").removeClass("hide");
                                    $(".alert-danger").addClass("show");
                                    setTimeout(function () {
                                        $(".alert-danger").removeClass("show");
                                        $(".alert-danger").addClass("hide");
                                    }, 5000);
                                }
                                self.hideLoader();
                            })
                            .catch(function (err) {
                                $("#save").val("Save");
                                $("#save").prop("disabled", false);
                                self.Registerbtn = "Register";
                                if (err.response.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    $('#errorMsg').html(err.response.data.message);
                                }
                                self.hideLoader();
                            });
                }
            },

            list401kDocs: function () {
                var path = window.location.pathname;
                var segments = path.split("/");

                var fields = {
                    segment: segments[2],
                    location_type: self.locationType.value,
                };
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                self.showLoader();
                HTTP.post('load401kdocs', fields, config).
                        then(response => {
                            self.doc401kList = response.data.content;
                            self.uploadLimitCounter = self.doc401kList.length;
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                            self.hideLoader();
                        });
            },

            changedValueDocument: function () {
                self.docSelectError = '';
            },
            intialConditionForAdvisor() {
                $("#showAdvisorBtn").hide();
                $("#updateAdvisorBtn").show();
                $("#updateAdvisor").hide();
                document.getElementById("firstName").disabled = true;
                document.getElementById("firstDesignation").disabled = true;
                document.getElementById("firstPhonePrimary").disabled = true;
                document.getElementById("firstPhoneSecondary").disabled = true;
                document.getElementById("firstEmail").disabled = true;

                document.getElementById("secondName").disabled = true;
                document.getElementById("secondDesignation").disabled = true;
                document.getElementById("secondPhonePrimary").disabled = true;
                document.getElementById("secondPhoneSecondary").disabled = true;
                document.getElementById("secondEmail").disabled = true;
            },
            onClickShowAdvisor() {
                $("#showAdvisorBtn").hide();
                $("#updateAdvisorBtn").show();
                $("#updateAdvisor").hide();
                document.getElementById("firstName").disabled = true;
                document.getElementById("firstDesignation").disabled = true;
                document.getElementById("firstPhonePrimary").disabled = true;
                document.getElementById("firstPhoneSecondary").disabled = true;
                document.getElementById("firstEmail").disabled = true;

                document.getElementById("secondName").disabled = true;
                document.getElementById("secondDesignation").disabled = true;
                document.getElementById("secondPhonePrimary").disabled = true;
                document.getElementById("secondPhoneSecondary").disabled = true;
                document.getElementById("secondEmail").disabled = true;
            },
            onClickUpdateAdvisor() {
                $("#showAdvisorBtn").show();
                $("#updateAdvisorBtn").hide();
                $("#updateAdvisor").show();
                document.getElementById("firstName").disabled = false;
                document.getElementById("firstDesignation").disabled = false;
                document.getElementById("firstPhonePrimary").disabled = false;
                document.getElementById("firstPhoneSecondary").disabled = false;
                document.getElementById("firstEmail").disabled = false;

                document.getElementById("secondName").disabled = false;
                document.getElementById("secondDesignation").disabled = false;
                document.getElementById("secondPhonePrimary").disabled = false;
                document.getElementById("secondPhoneSecondary").disabled = false;
                document.getElementById("secondEmail").disabled = false;
            },
            afterUpdateAdvisor() {
                $("#showAdvisorBtn").hide();
                $("#updateAdvisorBtn").show();
                document.getElementById("firstName").disabled = true;
                document.getElementById("firstDesignation").disabled = true;
                document.getElementById("firstPhonePrimary").disabled = true;
                document.getElementById("firstPhoneSecondary").disabled = true;
                document.getElementById("firstEmail").disabled = true;

                document.getElementById("secondName").disabled = true;
                document.getElementById("secondDesignation").disabled = true;
                document.getElementById("secondPhonePrimary").disabled = true;
                document.getElementById("secondPhoneSecondary").disabled = true;
                document.getElementById("secondEmail").disabled = true;
            },
            addNewStep: function () {
                self.instructions.push(Vue.util.extend({}, self.instruction))
            },
            removeStep: function (index) {
                Vue.delete(self.instructions, index);
            },
            removeAllFiles() {
                self.$refs.dropzone.removeAllFiles();
            },
            removedSelectedFile(file, xhr, error) {
                var filePath = JSON.parse(file.xhr.response);
                self.isFileUploaded = false;
                if ("media_thumb_path" in filePath.content) {
                    //self.mediaThumbnailPaths.pop(filePath.content.media_thumb_path);
                    self.removeFileFromServer(filePath.content.media_path, filePath.content.media_thumb_path);
                } else {
                    //self.mediaThumbnailPaths.pop(filePath.content.media_thumb_path);
                    self.removeFileFromServer(filePath.content.media_path, "");
                }
            },
            removeFileFromServer: function (filePath, thumbnailPath) {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    data: {
                        filePath: filePath,
                        thumbnailPath: thumbnailPath
                    }
                };
                HTTP.delete('removemedia', config)
                        .then(function (response) {
                            /*console.log("File removed successfully");*/
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            vfileSuccess: function (file, response) {
                self.isFileUploaded = true;
                self.docUploadError = '';
                var filePathJSON = JSON.parse(file.xhr.response);
                self.docPath = filePathJSON.content.media_path;

            },

            removeAllDocFiles() {
                self.$refs.dropzoneDocFile.removeAllFiles();
            },
            removedSelectedDocFile(file, xhr, error) {
                if(file && file.xhr && file.xhr.response){
                    self.isDocUploaded = false;
                    self.docPaths = '';
                    self.docTypes = '';
                    var filePath = JSON.parse(file.xhr.response);
                    //console.log(file);
                    if ("media_thumb_path" in filePath.content) {
                        //self.mediaThumbnailPaths.pop(filePath.content.media_thumb_path);
                        self.removeFileFromServer(filePath.content.media_path, filePath.content.media_thumb_path);
                    } else {
                        //self.mediaThumbnailPaths.pop(filePath.content.media_thumb_path);
                        self.removeFileFromServer(filePath.content.media_path, "");
                    }
                }
            },
            vDocfileSuccess: function (file, response) {
                self.docPaths = response.content.media_path;
                self.isDocUploaded = true;
                self.docUploadError = '';
                if ("media_thumb_path" in response.content) {
                    self.mediaThumbnailPaths = response.content.media_thumb_path;
                } else {
                    self.mediaThumbnailPaths.push("");
                    /*console.log("No media thumb");*/
                }
                self.docTypes = file.type;
            },

            checkForm() {
                var checked = true;
                if (self.isFileUploaded == false) {
                    self.docUploadError = 'Please Upload File';
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.fileUploaded == false) {
                    self.docUploadError = "Please Wait While File Is Being Uploaded";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.selectedUpload) {
                    self.docSelectError = 'Please Select Option';
                    if (checked) {
                        checked = false;
                    }
                }
                return checked;
            },

            loadDocName(loading, search, vm) {
                search = (search === null || typeof (search) === "undefined" || search == '') ? '' : search;
                var data = {
                    search: search,
                    location_type: self.locationType.value,
                };
                HTTP.post("get401kdocname", data)
                        .then(function (response) {
                            self.DocumentArr = response.data.content;
                            if (typeof (loading) != "undefined") {
                                loading(false);
                            }
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },

            updateDocs(type) {
                type = (type === null || typeof (type) === "undefined" || type == '') ? 'update' : type;
                if (self.checkForm()) {
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                    };
                    $("#update").val("Updating ...");
                    $("#update").prop("disabled", true);
                    /* var documentUp = (self.selectedUpload === null || self.selectedUpload == '') ? 0 : self.selectedUpload.value;*/
                    var fields = {
                        docId: self.selectedUpload.value,
                        docPath: self.docPath,
                        docType: self.docType,
                        /* docFor: documentUp,*/
                        docName: self.selectedUpload.text,
                        location_type: self.locationType.value,
                        type: type,
                    };
                    self.showLoader();
                    HTTP.post("update401kdocs", fields, config)
                            .then(function (response) {
                                if (response.data.status == "success") {
                                    /* $('select option[value="default"]').attr("selected",true);*/
                                    $("#update").val("Update");
                                    $("#update").prop("disabled", false);
                                    self.removeAllFiles();
                                    self.$swal({
                                        type: 'success',
                                        html: "Changes Applied Successfully",
                                        showConfirmButton: false,
                                        timer: 5000,
                                    });
                                    /* $('#selecteUpload').val("default");*/
                                    setTimeout(function () {
                                        self.load401kDocs();
                                        self.selectedUpload = {text: '', value: ''};
                                        $("#updateUploads").hide();
                                        $(".ViewDocument").hide();
                                        $("#viewUploads").show();
                                        $(".EditDocument").show();
                                    }, 10);
                                    self.removedSelectedFile();
                                } else {
                                    $("#update").val("Update");
                                    $("#update").prop("disabled", false);
                                    $("#errorMsg").html(response.data.message);
                                    if (response.data.content.length > 0) {
                                        var err = "";
                                        err += response.data.content + "<br>";
                                        $("#errorMsg").html(err);
                                    }
                                }
                                self.hideLoader();
                            })
                            .catch(function (err) {
                                $("#update").val("Update");
                                $("#update").prop("disabled", false);
                                self.Registerbtn = "Register";
                                if (err.response.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    $('#errorMsg').html(err.response.data.message);
                                }
                                self.hideLoader();
                            });
                }
            },

            load401kDocs() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };

                var data = {
                    id: 'all',
                    location_type: self.locationType.value,
                };
                self.showLoader();
                HTTP.post("list401kdocs", data, config)
                        .then(function (response) {
                            self.doc401kListNew = response.data.content;
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                            self.hideLoader();
                        });
            },

            checkContentForm() {
                var checked = true;
                if (!self.contactNumber) {
                    self.contactNumberError = "Contact Number Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.websiteLink) {
                    self.websiteLinkError = 'Please Enter Website Link';
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.websiteLink != '' && !self.validUrl(self.websiteLink)) {
                    self.websiteLinkError = 'Please Enter Valid URL';
                    if (checked) {
                        checked = false;
                    }
                }
                return checked;
            },

            updateContent() {
                self.checkContentForm();
                if (self.checkContentForm()) {
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                    };
                    $("#updateContent").val("Updating ...");
                    $("#updateContent").prop("disabled", true);
                    var fields = {
                        location_type: self.locationType.value,
                        instruction_title: self.instructionTitle,
                        instructions: self.instructions,
                        website_link: self.websiteLink,
                        contact_number: self.contactNumber,
                        description: self.description,
                    };
                    self.showLoader();
                    HTTP.post("update401kcontent", fields, config)
                            .then(function (response) {
                                if (response.data.status == "success") {

                                    self.$swal({
                                        type: 'success',
                                        html: "Changes Applied Successfully",
                                        showConfirmButton: false,
                                        timer: 5000,
                                    });
                                    setTimeout(function () {
                                        self.load401kContent();
                                        $("#updateContent").hide();
                                        $("#updateContent").val("Update");
                                        $("#updateContent").prop("disabled", false);

                                        $("#viewInstruction").show();
                                        $("#updateInstruction").hide();
                                        $("#showContent").hide();
                                        $("#updateContentBtn").show();
                                        document.getElementById("instructionTitle").disabled = true;
                                        document.getElementById("websiteLink").disabled = true;
                                        document.getElementById("contactNumber").disabled = true;
                                        document.getElementById("contactNumber").disabled = true;
                                        document.getElementById("description").disabled = true;
                                    }, 10);

                                } else {
                                    $("#updateContent").val("Update");
                                    $("#updateContent").prop("disabled", false);
                                    $("#errorMsg").html(response.data.message);
                                    if (response.data.content.length > 0) {
                                        var err = "";
                                        err += response.data.content + "<br>";
                                        $("#errorMsg").html(err);
                                    }
                                }
                                self.hideLoader();
                            })
                            .catch(function (err) {
                                $("#updateContent").val("Update");
                                $("#updateContent").prop("disabled", false);
                                self.Registerbtn = "Register";
                                if (err.response.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    $('#errorMsg').html(err.response.data.message);
                                }
                                self.hideLoader();
                            });
                }
            },

            load401kContent() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                var recordId = 1;
                if (self.locationType.value != "other") {
                    recordId = 2;
                }
                var data = {
                    id: recordId,
                    location_type: self.locationType.value,
                };
                self.showLoader();
                HTTP.post("list401kcontent", data, config)
                        .then(function (response) {
                            self.instructionTitle = response.data.content[0].instruction_title;
                            self.instructions = response.data.content[0].instruction;
                            self.instructionsForShow = response.data.content[0].instruction;
                            self.websiteLink = response.data.content[0].website_link;
                            self.contactNumber = response.data.content[0].contact_number;
                            self.description = response.data.content[0].description;
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                            self.hideLoader();
                        });
            },

            checkAdvisorForm() {
                var checked = true;
                if (!self.firstName) {
                    self.firstNameError = "Please Enter First Advisor Name";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.firstDesignation) {
                    self.firstDesignationError = 'Please Enter First Advisor Designation';
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.firstPhonePrimary) {
                    self.firstPhonePrimaryError = 'Please Enter Primary Phone Number';
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.firstPhonePrimary) {
                    if (/^[0-9- ,-]*$/.test(self.firstPhonePrimary) == false) {
                        self.firstPhonePrimaryError = 'Please Enter Valid Primary Phone Number';
                        if (checked) {
                            checked = false;
                        }
                    }
                }
                if (self.firstPhoneSecondary) {
                    if (/^[0-9- ,-]*$/.test(self.firstPhoneSecondary) == false) {
                        self.firstPhoneSecondaryError = 'Please Enter Valid Secondary Phone Number';
                        if (checked) {
                            checked = false;
                        }
                    }
                }
                if (!self.firstEmail) {
                    self.firstEmailError = 'Please Enter Email';
                    if (checked) {
                        checked = false;
                    }
                } else if (!self.validEmail(self.firstEmail)) {
                    self.firstEmailError = 'Please Enter Valid Email';
                    if (checked) {
                        checked = false;
                    }
                }

                if (!self.secondName) {
                    self.secondNameError = "Please Enter Second Advisor Name";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.secondDesignation) {
                    self.secondDesignationError = 'Please Enter second Advisor Designation';
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.secondPhonePrimary) {
                    self.secondPhonePrimaryError = 'Please Enter Primary Phone Number';
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.secondPhonePrimary) {
                    if (/^[0-9- ,-]*$/.test(self.secondPhonePrimary) == false) {
                        self.secondPhonePrimaryError = 'Please Enter Valid Primary Phone Number';
                        if (checked) {
                            checked = false;
                        }
                    }
                }
                if (self.secondPhoneSecondary) {
                    if (/^[0-9- ,-]*$/.test(self.secondPhoneSecondary) == false) {
                        self.secondPhoneSecondaryError = 'Please Enter Valid Secondary Phone Number';
                        if (checked) {
                            checked = false;
                        }
                    }
                }
                if (!self.secondEmail) {
                    self.secondEmailError = 'Please Enter Email';
                    if (checked) {
                        checked = false;
                    }
                } else if (!self.validEmail(self.secondEmail)) {
                    self.secondEmailError = 'Please Enter Valid Email';
                    if (checked) {
                        checked = false;
                    }
                }

                return checked;
            },

            validEmail: function (email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },

            updateAdvisor() {
                self.checkAdvisorForm();
                if (self.checkAdvisorForm()) {
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                    };
                    $("#updateAdvisor").val("Updating ...");
                    $("#updateAdvisor").prop("disabled", true);
                    var fields = {
                        location_type: self.locationType.value,

                        first_advisor_name: self.firstName,
                        first_designation: self.firstDesignation,
                        first_primary_phone: self.firstPhonePrimary,
                        first_secondary_phone: self.firstPhoneSecondary,
                        first_email: self.firstEmail,

                        second_advisor_name: self.secondName,
                        second_designation: self.secondDesignation,
                        second_phone_primary: self.secondPhonePrimary,
                        second_phone_secondary: self.secondPhoneSecondary,
                        second_email: self.secondEmail,
                    };
                    self.showLoader();
                    HTTP.post("update401kadvisor", fields, config)
                            .then(function (response) {
                                if (response.data.status == "success") {

                                    self.$swal({
                                        type: 'success',
                                        html: "Changes Applied Successfully",
                                        showConfirmButton: false,
                                        timer: 5000,
                                    });
                                    setTimeout(function () {
                                        self.load401kAdvisor();
                                        $("#updateAdvisor").hide();
                                        $("#updateAdvisor").val("Update");
                                        $("#updateAdvisor").prop("disabled", false);
                                        self.afterUpdateAdvisor();
                                    }, 10);

                                } else {
                                    $("#updateContent").val("Update");
                                    $("#updateContent").prop("disabled", false);
                                    $("#errorMsg").html(response.data.message);
                                    if (response.data.content.length > 0) {
                                        var err = "";
                                        err += response.data.content + "<br>";
                                        $("#errorMsg").html(err);
                                    }
                                }
                                self.hideLoader();
                            })
                            .catch(function (err) {
                                $("#updateContent").val("Update");
                                $("#updateContent").prop("disabled", false);
                                self.Registerbtn = "Register";
                                if (err.response.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    $('#errorMsg').html(err.response.data.message);
                                }
                                self.hideLoader();
                            });
                }
            },

            load401kAdvisor() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                var recordId = 1;
                if (self.locationType.value != "other") {
                    recordId = 2;
                }
                var data = {
                    id: recordId,
                    location_type: self.locationType.value,
                };
                self.showLoader();
                HTTP.post("list401kadvisor", data, config)
                        .then(function (response) {
                            self.firstName = response.data.content[0].first_advisor_name;
                            self.firstDesignation = response.data.content[0].first_designation;
                            self.firstPhonePrimary = response.data.content[0].first_primary_phone;
                            self.firstPhoneSecondary = response.data.content[0].first_secondary_phone;
                            self.firstEmail = response.data.content[0].first_email;

                            self.secondName = response.data.content[0].second_advisor_name;
                            self.secondDesignation = response.data.content[0].second_designation;
                            self.secondPhonePrimary = response.data.content[0].second_phone_primary;
                            self.secondPhoneSecondary = response.data.content[0].second_phone_secondary;
                            self.secondEmail = response.data.content[0].second_email;
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                            self.hideLoader();
                        });
            },

            formatString(data) {
                var self = this;
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            },
            progressOfUload(totaluploadprogress, totalBytes, totalBytesSent) {
                if (totaluploadprogress == 100) {
                    self.fileUploaded = true;
                    self.docUploadError = "";
                } else {
                    self.fileUploaded = false;
                }
            },
            //
        },

    }
</script>



// WEBPACK FOOTER //
// src/components/backend/401k/ViewUpdate401k.vue